import { render, staticRenderFns } from "./PendingOrderlist.vue?vue&type=template&id=16886be2&scoped=true"
import script from "./PendingOrderlist.vue?vue&type=script&lang=js"
export * from "./PendingOrderlist.vue?vue&type=script&lang=js"
import style0 from "./PendingOrderlist.vue?vue&type=style&index=0&id=16886be2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16886be2",
  null
  
)

export default component.exports